<template>
    <b-modal id="modal-import" ref="importModal" title="导入数据" hide-footer>
        <b-form @submit="handleSubmit" @reset="handleReset">
            <b-form-group
                id="templateFile"
                label="选择数据源文件:"
                label-for="input-dataFile"
                invalid-feedback="必须选择数据源">
                <b-form-file id="input-dataFile" v-model="file" ref="file-input" class="mb-2"
                             :browse-text="$t('btn.basic.browse')" placeholder="请选择数据文件"
                             :file-name-formatter="formatNames"
                             accept=".xls,.xlsx" required></b-form-file>
            </b-form-group>
            <b-row align-h="end" style="margin-top: 30px">
                <b-button type="submit" variant="primary">导入</b-button>
                <b-button type="reset" variant="light">取消</b-button>
            </b-row>
        </b-form>
    </b-modal>
</template>

<script>
import commonViewsUtil from "@/utils/commonViewsUtil";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "em-table-import",
    mixins: [emCommonApiMixin],
    props: {
        entity: {
            type: String
        },
    },
    data() {
        return {
            file: null,
        }
    },
    methods: {
        show() {
            this.file = null
            this.$refs["importModal"].show()
        },
        formatNames(files) {
            return files.length === 1 ? files[0].name : `${files.length} files selected`
        },
        handleSubmit(event) {
            event.preventDefault()
            let formData = new FormData();
            formData.append('file', this.file);

            this.$emit('begin');
            this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.entity)}/import`, formData)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "更新成功")
                    //让页面刷新数据
                    this.$store.commit(`${this.entity}/setNeedToRefresh`, true, {
                        root: true
                    })
                }).finally(() => this.$emit('end'));

            this.$nextTick(() => {
                this.$bvModal.hide('modal-import')
            })
        },
        handleReset() {
            this.selectedMachineType = null;
            this.file = null;
            this.$nextTick(() => {
                this.$bvModal.hide('modal-import')
            })
        },
    }
}
</script>